import { numericFormatter } from 'react-number-format';
import { Currencies, getCurrencyFormat, isCurrencySymbolBefore } from '../data/Currencies';
export const formatNumber = (amount = 0, currencyCode = 'USD') => {
    const value = typeof amount === 'string' ? parseInt(amount, 10) : amount === null ? 0 : amount;
    const currency = Currencies.find((c) => c.code === currencyCode);
    const symbol = currencyCode === false
        ? ''
        : { [isCurrencySymbolBefore(currencyCode) ? 'prefix' : 'suffix']: currency.symbolNative };
    return numericFormatter(currencyCode === false ? value?.toString() : value ? (value / currency.numberToBasic).toString() : '0', {
        thousandSeparator: currencyCode === false ? true : getCurrencyFormat(currencyCode, 'thousandSeperator'),
        decimalScale: currencyCode === false ? 0 : currency.decimalDigits,
        fixedDecimalScale: true,
        decimalSeparator: currencyCode === false ? undefined : (getCurrencyFormat(currency.code, 'decimalSeperator') ?? '.'),
        displayType: 'text',
        renderText: (v) => v.toString(),
        ...symbol,
    });
};
//# sourceMappingURL=formatNumber.js.map